import { Main } from "components/aud/base/Main";
import { Section } from "components/aud/base/Section";
import Head from "next/head";
import { PageTitle } from "components/aud/ui/PageTitle";
import { Image } from "~/components/Image";

const css = {
  link: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    display: "block",
    maxWidth: "320px",
    textDecoration: "none",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    maxWidth: "none",
    display: "block",
  },
  text: {
    padding: "8px",
    borderTop: "1px solid #ddd",
  },
} as const;

const BrandAssetsPage = () => {
  return (
    <Main nav="policies">
      <Head>
        <title>ロゴなどのブランドアセットの利用について</title>
      </Head>
      <Section withInner>
        <PageTitle title="Brand Assets" sub="ロゴなどのブランドアセットの利用について" />
        <div className="_markdown">
          <p>
            メディアやNowDoerのみなさんに自由にお使いいただけるロゴ素材をご用意しました。利用ルールをよく理解し、同意した上でご活用ください。
          </p>
          <h1>利用ルール</h1>
          <h2>NowDoerのみなさんへ</h2>
          <ul>
            <li>ブランドアセットのブログ・SNSなどへの掲載利用は自由です。</li>
            <li>
              改変に関しては推奨しておりませんが、常識の範囲であれば可能です。NowDoは大切なブランドであり、それを見た人にネガティブな印象を与えないよう気を付けてください。
            </li>
            <li>
              個人のグッズ制作なども自由に行っていただいて構いませんが、公式に承認は致しません。
              <span className="red">非公式であることを必ず説明してください。</span>
            </li>
          </ul>
          <h2>ご確認ください</h2>
          <ul>
            <li>企業や個人事業者などの法人・事業団体がロゴを使ってグッズを制作・販売することはできません。</li>
            <li>NowDo運営からロゴ利用の差し止め要求があった場合は速やかに利用を中止してください。</li>
            <li>
              以後、利用ルールが変わった場合はそれに従ってください。（ただし、利用料などを求めることはありません）
            </li>
          </ul>

          <h1>ブランドアセット</h1>

          <h2>ロゴ素材</h2>
          <a
            href="https://drive.google.com/drive/folders/1-145F93cMKL1mzpGjxhO2GEH6XNDGs5M?usp=sharing"
            target="_blank"
            style={css.link}
            rel="noreferrer"
          >
            <Image src="/images/brand__logo.png" width={640} height={345} alt="" />
            <p style={css.text}>
              <span className="_button primary small">ダウンロード</span>
              <span className="gray">.svg, .png</span>
            </p>
          </a>

          <h2>壁紙</h2>
          <a
            href="https://drive.google.com/drive/folders/148iXwi-I6U-ZKm2F9kdcrdyltdI4Id_x?usp=sharing"
            target="_blank"
            style={css.link}
            rel="noreferrer"
          >
            <Image src="/images/brand__wp.png" width={640} height={345} alt="" />
            <p style={css.text}>
              <span className="_button primary small">ダウンロード</span>
              <span className="gray">.svg, .png</span>
            </p>
          </a>

          {/* <h2>スクリーンショット</h2>
          <p className="gray">準備中</p> */}
        </div>
      </Section>
    </Main>
  );
};

export default BrandAssetsPage;
